<app-common-page-breadcrumbs [pageTitle]="title" [navigationData]="navigationData"></app-common-page-breadcrumbs>
<div id="loader" *ngIf="enableLoader"></div>
<div *ngIf="!enableLoader">
<div class="filter-nav overflow-visible ">
    <div class="container d-none d-lg-block">
      <div class="d-flex">
        <div class="d-flex">
          <div class="md-semibold-font text-black small p-2 text-nowrap">{{ 'home.productHeader.Filter' | cxTranslate }}</div>
          <div class="mr-2">
            <ng-select [items]="portData" [multiple]="true" [clearable]="false" bindLabel="name" dropdownPosition="bottom"
              groupBy="ports" [selectableGroup]="false" [closeOnSelect]="true" placeholder="{{'shipment.SelectPorts' | cxTranslate}}" bindValue="id"
              [(ngModel)]="selectedPort" notFoundText="No Items Found" (change)="changePorts(false)">
              <ng-template ng-multi-label-tmp>
                <span class="filter-count pl-2 text-black">{{selectedPort?.length}}x{{ 'shipment.Ports' | cxTranslate }}</span>
              </ng-template>
              <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index" class="dropdown-ng-template">
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <div (pointerdown)="getPortFacets(item)">
                  <input *ngIf="item.name!==undefined && item.name!==''" id="{{item.id}}" type="checkbox"
                    [ngModel]="item$.selected" [checked]="item.selected" /> <span>{{item.name}}</span>
                </div>
              </ng-template>
            </ng-select>
            </div> 
            <!-- <div class="mr-2">
              <ng-select [items]="AgentsList" [multiple]="true" [clearable]="false" bindLabel="name" dropdownPosition="bottom"
                groupBy="AgentsList" [selectableGroup]="false" [closeOnSelect]="true" placeholder="Select Agents" bindValue="id"
                [(ngModel)]="selectedAgent" notFoundText="No Items Found" (change)="changeAgents()">
                <ng-template ng-multi-label-tmp>
                  <span class="filter-count pl-2 text-black">{{selectedAgent?.length}}x Agents Selected</span>
                </ng-template>
                <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                  <input type="checkbox" /><span class="ff-semibold "> Agents</span>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                  <div (pointerdown)="getAgentsFacets(item)">
                    <input *ngIf="item.name!==undefined && item.name!==''" id="{{item.id}}" type="checkbox"
                      [ngModel]="item$.selected" [checked]="item.selected" /> <span>{{item.name}}</span>
                  </div>
                </ng-template>
              </ng-select>
              </div>  -->
              <div class="mr-2">
                <ng-select [items]="StatusList" [multiple]="true" [clearable]="false" bindLabel="name" dropdownPosition="bottom"
                  groupBy="StatusList" [selectableGroup]="false" [closeOnSelect]="true" placeholder="{{'shipment.SelectStatus' | cxTranslate}}" bindValue="code"
                  [(ngModel)]="selectedStatus" notFoundText="No Items Found" (change)="changeStatus(false)">
                  <ng-template ng-multi-label-tmp>
                    <span class="filter-count pl-2 text-black">{{selectedStatus?.length}}x {{'shipment.statusselected' | cxTranslate}}</span>
                  </ng-template>
                  <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                    <input type="checkbox" /><span class="ff-semibold "> {{'shipment.status' | cxTranslate}}</span>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    <div>
                      <input *ngIf="item.name!==undefined && item.name!==''" id="{{item.code}}" type="checkbox"
                        [ngModel]="item$.selected" [checked]="item.selected" /> <span>{{item.name}}</span>
                                 </div>
                      </ng-template>
                </ng-select>
                </div> 
          <div *ngIf="showClear">
            <button type="button" class="btn btn-warning clear-text " (click)="clearAllFilter(false)">{{
              'home.productHeader.ClearFilter' | cxTranslate }}</button>
          </div> 
        </div>
        <div class="ml-auto d-flex">
            <div class="mr-4 d-none d-lg-block">
              <div class="d-flex" *ngIf="display === 'shipmentList' || display === 'bondedwarehouseShipmentList'">
              <a (click)="donwloadShipmentRpeort(display === 'shipmentList' ? 'shipmentlist_report' : 'seaborne_shipmentlist_report')" class="mr-2 mt-2"  >{{'shipment.Export' | cxTranslate}}</a>
              <button type="button" (click)="donwloadShipmentRpeort(display === 'shipmentList' ? 'shipmentlist_report' : 'seaborne_shipmentlist_report')" style="min-height: 42px;" class="float-right d-none d-sm-block btn btn-secondary" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false"><img src="./images/download_report.svg" alt="customlogo" width="25px" height="25px"> &nbsp;
              {{'shipment.Export' | cxTranslate}}
            </button>
          </div>
          <div class="d-flex" *ngIf="display === 'inspectionPage'">
            <a (click)="donwloadShipmentRpeort('INSP_REPORT')" class="mr-2 mt-2"  >{{'shipment.Export' | cxTranslate}}</a>
              <button type="button" (click)="donwloadShipmentRpeort('INSP_REPORT')" style="min-height: 42px;" class="float-right d-none d-sm-block btn btn-secondary" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false"><img src="./images/download_report.svg" alt="customlogo" width="25px" height="25px"> &nbsp;
              {{'shipment.Export' | cxTranslate}}
            </button>
          </div>
          <div class="d-flex" *ngIf="display === 'bondedwarehouseInspectionPage'">
            <a (click)="donwloadShipmentRpeort('bonded_warehouse_inspection_report')" class="mr-2 mt-2"  >{{'shipment.Export' | cxTranslate}}</a>
              <button type="button" (click)="donwloadShipmentRpeort('bonded_warehouse_inspection_report')" style="min-height: 42px;" class="float-right d-none d-sm-block btn btn-secondary" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false"><img src="./images/download_report.svg" alt="customlogo" width="25px" height="25px"> &nbsp;
              {{'shipment.Export' | cxTranslate}}
            </button>
          </div>
            <!-- <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuLink">
              <a class="dropdown-item"  >{{'shipment.shipmentreport' | cxTranslate}}</a>
              <a class="dropdown-item">{{'shipment.inspectionReport' | cxTranslate}}</a>
            </div> -->
            </div>
        <!--search function desktop-->
        <div class="d-flex align-items-center mr-2 search-section-col">
          <div class="search-section-div">
            <div class="input-group d-flex align-items-center">
              <input class="form-control form-control-lg border rounded-pill input-field" type="search"
                (keypress)="omitSpecialChar($event)" [(ngModel)]="searchText" (input)="search()"
                placeholder="{{ 'home.productHeader.Search' | cxTranslate }}">
              <span class="input-group-append">
                <button name='searchbuttondesktop'
                  class="btn btnUpgrade rounded-pill border-0 input-field bg-white border-start-0 border-bottom-0 border ms-n5"
                  type="button">
                  <i class="fa fa-search pe-none"></i>
                </button>
              </span>
            </div>
          </div>
        </div>
        <!-- <div class="d-inline-flex contractsearch search-zindex filter-select-div">
          <div class="input-group">
            <input class="form-control" [(ngModel)]="searchText" type="search"
              placeholder="Search by shipment" id="example-search-input" (input)="search()" (keypress)="omitSpecialChar($event) " />
          </div>
        </div> -->
      </div>
    </div>
    </div>
    <div class="container d-lg-none">
      <div class="row">
        <div class="w-100">
          <div class="filter-select-div-mobile pl-4 pb-2">
            <div class="input-group align-items-center">
              <input class="form-control border rounded-pill input-field" type="search" (input)="search()"
                (keypress)="omitSpecialChar($event)" [(ngModel)]="searchText" placeholder="{{'shipment.search' | cxTranslate}}" (input)="search()">
              <span class="input-group-append d-flex align-items-center">
                <button name='searchbuttonfilter' class="
                        btn
                        btnUpgrade
                        border-0
                        input-field
                        border-start-0 border-bottom-0 border
                        ms-n5 
                      " type="button">
                  <i class="fa fa-search mobbar"></i>
                </button>
                <!-- Add vertical divider between search and export -->
                <span class="mx-2 line" ></span>
                <div class="ml-1">
                  <button type="button" *ngIf="display === 'shipmentList' || display === 'bondedwarehouseShipmentList'" style="min-height: auto;"
                    class="btn btn-sm btn-secondary " href="#" role="button" (click)="donwloadShipmentRpeort('shipmentlist_report')"
                    id="dropdownMenuLink"><img src="/images/download_report.svg" alt="customlogo"
                     width="25px" height="25px">
                    </button>
                  <button type="button"  *ngIf="display === 'inspectionPage'" style="min-height: auto;"          
                    class="btn btn-sm btn-secondary " href="#" role="button" (click)="donwloadShipmentRpeort('INSP_REPORT')" 
                    id="dropdownMenuLink"><img src="/images/download_report.svg" 
                      alt="customlogo" width="25px" height="25px">
                  </button>
                  <button type="button"  *ngIf="display === 'bondedwarehouseInspectionPage'" style="min-height: auto;"
                    class="btn btn-sm btn-secondary " href="#" role="button" (click)="donwloadShipmentRpeort('bonded_warehouse_inspection_report')" 
                    id="dropdownMenuLink"><img src="/images/download_report.svg" 
                      alt="customlogo" width="25px" height="25px">
                    </button>
                </div>
                <!-- Add vertical divider between export and filter -->
                <span class="mx-2 line"></span>
                <div class='hidden-xs-filter-bar pr-1 ml-1' (click)='filtersidebar()'>
                  <img class="ml-1" src="./images/filternew.svg"><sup class="pl-2 pr-2 pt-1 pb-1"
                    *ngIf='length'>{{length}}</sup>
                  <div class="ff-semibold fs-10 d-flex align-items-center text-black Filternew">{{ 'home.filter.filters' |
                    cxTranslate }}</div>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="">
        <div [ngClass]="sidebar ?'hide-mobile-filter-sidebar': 'mobile-filter-sidebar' "
          class="hidden-xs-filter-bar sidebar">
          <div class='sticky-top  d-flex justify-content-between p-3 border sticky'>
            <div class="fs-24 md-semibold-font pl-1">{{ 'home.productHeader.Filter' | cxTranslate }}:</div>
            <div (click)="closebar()"><img src="/images/sidebarcross.svg" alt=""> </div>
          </div>
          <div class="scrollbar">
            <div>
              <div class="d-flex md-semibold-font small pl-3 pt-3 pb-2"> {{'shipment.ports' | cxTranslate}} :</div>
              <div *ngFor="let ports of portData; let i=index" class="ml-5 small d-flex line-height">
                <label class="ff-normal" *ngIf="ports.name!==undefined && ports.name!==''">
                  <input type="checkbox" [(ngModel)]="ports.selected" [value]="ports.id"
                    [checked]="ports.selected" (change)="portsmobileFilter($event, ports.id)" />
                  {{ports.name}}
                </label>
              </div>
            </div>
            <!-- <div>
              <div class="d-flex md-semibold-font small pl-3 pt-3 pb-2">Agents :</div>
              <div *ngFor="let agents of AgentsList; let i=index" class="ml-5 small d-flex line-height">
                <label class="ff-normal" *ngIf="agents.name!==undefined && agents.name!==''">
                  <input type="checkbox" [(ngModel)]="agents.selected" [value]="agents.id"
                    [checked]="agents.selected" (change)="getFacetsMobile(agents)" />
                  {{agents.name}}
                </label>
              </div>
            </div> -->
            <div>
              <div class="d-flex md-semibold-font small pl-3 pt-3 pb-2">{{'shipment.status' | cxTranslate}} :</div>
              <div *ngFor="let status of StatusList; let i=index" class="ml-5 small d-flex line-height">
                <label class="ff-normal" *ngIf="status.name!==undefined && status.name!==''">
                  <input type="checkbox" [(ngModel)]="status.selected" [value]="status.code"
                    [checked]="status.selected" (change)="statusmobileFilter($event, status.code)" />
                  {{status.name}}
                </label>
              </div>
            </div>
          </div>  
          <div class="sticky-bottom p-4 border-top">
            <button class="btn btn-block btn-primary w-100" (click)="getResults()">{{ 'home.contracts.seeResults'|cxTranslate}}</button>
            <button class='btn btn-block' (click)="clearFilterDataMobile($event);closebar()">{{ 'home.contracts.clearFilter' |
              cxTranslate}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container" >
    <div class="row d-flex justify-content-between px-2 pt-4" >
      <div class="col-lg-2 tabDiv">
        <nav class="product-tab ">
          <div class="nav nav-fill nav-tabs pe-auto" id="nav-tab" role="tablist"> 
            <div class="nav-item nav-link active tab-bar strong fs-14" [class.active]="activeTab === 'Active'" id="nav-profile-tab" data-toggle="tab"
              role="tab" aria-controls="nav-profile" aria-selected="true" (click)="changeTab('Active')"
             > {{'shipment.Active' | cxTranslate}}
            </div>
            <div class="nav-item nav-link  tab-bar strong fs-14" [class.active]="activeTab === 'Completed'" id="nav-home-tab" data-toggle="tab"
              role="tab" aria-controls="nav-home" aria-selected="false" (click)="changeTab('Completed')"
             >{{'shipment.Completed' | cxTranslate}}
            </div>
          </div>
        </nav>
      </div>
      <!-- <div>
        <span class="grid-icon ml-3">Display as:
          <img class="grid-icon" title="grid" [src]='gridSrc' (click)="viewGrid()" >
          <img class="list-icon" title="list" [src]='listSrc' (click)=" viewList()">
      </span>
      </div> -->
    </div>
    <div class="border-bottom"></div>
</div>

<div class="container "  *ngIf="(activeTab==='Active' || activeTab === 'Completed') && !enableLoader"  infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="50" (scrolled)="onScrollGrid()" [scrollWindow]="true" [infiniteScrollDisabled]="reachedToEnd === true">       
  <div *ngIf="shipmentdata && shipmentdata.length === 0 && !enableLoader && (display === 'shipmentList' || display === 'bondedwarehouseShipmentList')" class="text-center strong  text-secondary my-5">
      {{'home.contracts.Noresults' | cxTranslate }}</div>
  <div *ngIf="shipmentinspectiondata && shipmentinspectiondata.length === 0 && !enableLoader && (display === 'inspectionPage' || display === 'bondedwarehouseInspectionPage')" class="text-center strong  text-secondary my-5">
      {{'home.contracts.Noresults' | cxTranslate }}</div>
      
  <!-- <div *ngIf="grid==true">
  <div class="row flex-wrap" >
      <div class="col-md-6 col-lg-4 "  *ngFor="let shipdata of shipmentdata">
      <div class="card card-body mt-4 mb-4 p-3 border-radius-05">
          <div class="d-flex">
          <div class="">{{shipdata.shipID}}</div>
          <div class="badge badge-light">{{shipdata.ShipStatus}}</div>
      </div >
          <hr>
          <div>
              <div class="d-flex"> 
                  <ul>
                  <li class="strong h5 mb-0" >{{shipdata && shipdata.Ship_name || '---'}}</li> 
                 <li class="small text-secondary small">{{shipdata && shipdata.Ship_name1 || '---'}}</li>
                  </ul>
              </div>
              <div class="row">
                  <div class="col">
                      <div class="small text-secondary small">Discharge completed</div>
                      <div class="strong small itenerary-location">{{shipdata && shipdata.Dischargeportcompleted}}</div>
                  </div>
                  <div class="col">
                      <div class="small text-secondary small">Customs clearance</div>
                      <div class="strong small itenerary-location">{{shipdata && shipdata.customerClearance}}</div>
                  </div>
                  <div class="col" >
                    <div class="small text-secondary small">BL QTY</div>
                    <div class=" small">{{shipdata && shipdata.BL_Qty}}</div>
                </div>
                <div class="col">
                    <div class="small text-secondary small">ETCD</div>
                    <div class="small">{{shipdata && shipdata.ETCD}}</div>
                </div>
                <div class="col">
                    <div class="small text-secondary small">Cargo agent</div>
                    <div class="small">{{shipdata && shipdata.cargo_operator}}</div>
                </div>
              </div>
          </div>
          <hr>
          <div>
              <div class="btn btn-link p-0  float" (click)="gotoDeatils(shipdata.shipID)">View details ></div>
          </div>
      </div>
      </div>
  </div>
  </div> -->
  <div *ngIf="list==true">
    <!-- shipment List code start-->
      <div class="" *ngIf="display === 'shipmentList' || display === 'bondedwarehouseShipmentList'">
        
                    <div class="col-md-12 mt-4 col-lg-12 " *ngFor="let shipdata of shipmentdata">
                      <div class="card mt-2 mb-2 card-border border-radius-05">
                        <div *ngIf="shipdata.shipmentArrivalStatusCode == 'NEW'" style="background-color:#0A6CB4;"
                          class="card-header borderRadius pb-1">
                          <div class="d-flex justify-content-between">
                            <div class=""><span class="mr-1"><img class="mb-1" src="./images/ship.svg" alt="icon" width="35"
                                  height="20"></span><span>{{shipdata.nominationNumber}}/{{shipdata.nominationItemNumber|
                                removeLeadingZeros}}</span></div>
                            <div class="d-flex justify-content-between">
                              <span class="mr-5  d-none d-md-block d-lg-block">{{ 'home.quote.Creationdate' | cxTranslate }}
                                {{convertDateOnly(shipdata.creationDate)}}</span>
                              <div class="badge badge-success ml-auto fs-12 mb-1">{{shipdata.status}}</div>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="shipdata.shipmentArrivalStatusCode == 'ASSIGNED'" style="background-color:#06AD96;"
                          class="card-header borderRadius pb-1">
                          <div class="d-flex justify-content-between">
                            <div class=""><span class="mr-1"><img class="mb-1" src="./images/ship.svg" alt="icon" width="35"
                                  height="20"></span><span>{{shipdata.nominationNumber}}/{{shipdata.nominationItemNumber|
                                removeLeadingZeros}}</span></div>
                            <div class="d-flex justify-content-between ">
                              <span class="mr-5 d-none d-md-block d-lg-block">{{ 'home.quote.Creationdate' | cxTranslate }}
                                {{convertDateOnly(shipdata.creationDate)}}</span>
                              <div class="badge badge-indigo ml-auto fs-12 mb-1">{{shipdata.status}}</div>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="shipdata.shipmentArrivalStatusCode == 'INPROGRESS'" style="background-color:#E87202;"
                          class="card-header borderRadius pb-1">
                          <div class='d-flex justify-content-between'>
                            <div class=""><span class="mr-1"><img class="mb-1" src="./images/ship.svg" alt="icon" width="35"
                                  height="20"></span><span>{{shipdata.nominationNumber}}/{{shipdata.nominationItemNumber|
                                removeLeadingZeros}}</span></div>
                            <div class="d-flex justify-content-between ">
                              <span class="mr-5 d-none d-md-block d-lg-block">{{ 'home.quote.Creationdate' | cxTranslate }}
                                {{convertDateOnly(shipdata.creationDate)}}</span>
                              <div class="badge badge-success ml-auto fs-12 mb-1">{{shipdata.status}}</div>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="shipdata.shipmentArrivalStatusCode == 'COMPLETED'" style="background-color:#6C757D;"
                          class="card-header borderRadius pb-1 pl-2">
                          <div class='d-flex justify-content-between'>
                            <div class=""><span class="mr-1"><img class="mb-1" src="./images/ship.svg" alt="icon" width="35"
                                  height="20"></span><span>{{shipdata.nominationNumber}}/{{shipdata.nominationItemNumber|
                                removeLeadingZeros}}</span></div>
                            <div class="d-flex justify-content-between d-none d-md-block d-lg-block ">
                              <span class="mr-5 ">{{ 'home.quote.Creationdate' | cxTranslate }}
                                {{convertDateOnly(shipdata.creationDate)}}</span>
                             <div class="badge badge badge-completed ml-auto fs-12 mb-1">{{shipdata.status}}</div>

                            </div>
                          </div>
                        </div>
                        <div class="card-body d-none d-lg-block">
                          <div class='d-flex py-2 text-break'>
                            <div class="pl-1 d-none d-md-block d-lg-block col-md-2">
                              <div class="h5 mb-0 fw-bold">{{shipdata.vesselName?shipdata.vesselName:'--'}}</div>
                              <div class="small text-secondary">{{shipdata.portName?shipdata.portName:'--'}}</div>
                            </div>
                            <div class="d-none d-md-block d-lg-block col-md-2">
                              <div class="small text-secondary">{{'shipment.material' | cxTranslate}}</div>
                              <div class="small text-black">{{shipdata.material?shipdata.material:'--'}}</div>
                            </div>
                            <div class="col-md-6">
                              <div class="row">
                                <div class="d-none d-md-block d-lg-block col-md-3">
                                  <div class="small text-secondary">{{'shipment.Dischargecompleted' | cxTranslate}}</div>
                                  <div [ngStyle]="{'background-color':shipdata?.isDischarged === false ?'#01515F':'#28A745'}"
                                    class="small text-white badge">{{shipdata.isDischargedLocale}}</div>
                                </div>
                                <div *ngIf="display === 'shipmentList'" class="d-none d-md-block d-lg-block col-md-3">
                                  <div class="small text-secondary">{{'shipment.Customsclearance' | cxTranslate}}</div>
                                  <div [ngStyle]="{'background-color':shipdata?.isCustomCleared === false ?'#01515F':'#28A745'}"
                                    class="small text-white badge">{{shipdata?.isCustomClearedLocale}}</div>
                                </div>
                                <div class="d-none d-md-block d-lg-block col-md-3">
                                  <div class="small text-secondary">{{'shipment.BLQty' | cxTranslate}}</div>
                                  <div class="small">{{shipdata.formattedActualQuantity}}</div>
                                </div>
                                <div class="d-none d-md-block d-lg-block col-md-3 ">
                                  <div class="small text-secondary">{{ "shipment.ETCD" | cxTranslate }}</div>
                                  <div class="small text-secondary fs-12">{{shipdata.etcd?shipdata.etcd: 'DD/MM/YYYY-HH:MM'}}</div>
                                </div>
                              </div>
                            </div>
                            <div class="d-none d-md-block d-lg-block col-md-2">
                              <div class="small text-secondary">{{'shipment.Cargoagent' | cxTranslate}}</div>
                              <div class="small">{{shipdata.portSidePartner?shipdata.portSidePartner: '--'}}</div>
                            </div>
                          </div>
                        </div>
                        <!-- Mobile view INPROGRESS/completed tab-->
                        <span class="ml-3 mt-2 text-secondary small  d-lg-none">{{ 'home.quote.Creationdate' | cxTranslate }}
                                {{convertDateOnly(shipdata.creationDate)}}</span>
                        <div class="py-4 d-lg-none">
                          <div class="px-3 row mt-3">
                            <div class="col-10 h6 ml-2 mb-0 fw-bold">{{shipdata.vesselName?shipdata.vesselName:'--'}}</div>
                            <div class="col-10 small mr-3 text-secondary">{{shipdata.portName?shipdata.portName:'--'}}</div>
                          </div>
                        </div>
                        <!-- End  -->
                        <!-- Mobile View Active/Completed tab -->
                        <div class="hr mt-0 mb-0 d-lg-none"></div>
                        <div class="py-2 d-lg-none">
                          <div class="px-3 row mt-3">
                            <div class="col-6 small strong text-secondary">{{'shipment.material' | cxTranslate}}</div>
                            <div class="col-6 small text-black">{{shipdata.material?shipdata.material:'--'}}</div>
                          </div>
                          <div class="px-3 row mt-3">
                            <div class="col-6 small strong text-secondary">{{'shipment.Dischargecompleted' | cxTranslate}}</div>
                            <div class="col-6"><div class="small text-white badge" [ngStyle]="{'background-color':shipdata?.isDischarged === false ?'#01515F':'#28A745'}"
                              >{{shipdata.isDischargedLocale}}</div></div>
                          </div>
                          <div *ngIf="display === 'shipmentList'" class="px-3 row mt-3">
                            <div class="col-6 small strong text-secondary">{{'shipment.Customsclearance' | cxTranslate}}</div>
                            <div class="col-6"><div class="small text-white badge" [ngStyle]="{'background-color':shipdata?.isCustomCleared === false ?'#01515F':'#28A745'}"
                              >{{shipdata?.isCustomClearedLocale}}</div></div>
                          </div>
                          <div class="px-3 row mt-3">
                            <div class="col-6 small strong text-secondary">{{'shipment.BLQty' | cxTranslate}}</div>
                            <div class="col-6 small">{{shipdata.formattedActualQuantity }}</div>
                          </div>
                          <div class="px-3 row mt-3">
                            <div class="col-6 small strong text-secondary">{{ "shipment.ETCD" | cxTranslate }}</div>
                            <div class="col-6 small text-secondary">{{shipdata.etcd?shipdata.etcd: '--'}}</div>
                          </div>
                          <div class="px-3 row mt-3">
                            <div class="col-6 small strong text-secondary">{{'shipment.Cargoagent' | cxTranslate}}</div>
                            <div class="col-6 small">{{shipdata.portSidePartner?shipdata.portSidePartner: '--'}}</div>
                          </div>
                        </div>
                    
                        <!-- End Mobile view  -->
                        <!-- <div class="hr mt-0 mb-2"></div>
                        <div class="ml-3 mb-2 d-flex justify-content-between">
                          <div class="d-none d-md-block d-lg-block mt-2 ml-1">
                            <div class="strong text-primary pe-auto" (click)="gotoDeatils(shipdata,'view')">
                              {{'shipment.Viewdetails' | cxTranslate}} ></div>
                          </div>
                          <div class="d-md-none d-lg-none mt-2">
                            <div class="strong text-primary pe-auto" (click)="gotoDeatils(shipdata,'view')">
                              {{'shipment.Viewdetails' | cxTranslate}} ></div>
                          </div>
                          <div *ngIf="(shipdata.shipmentArrivalStatusCode =='NEW')" class="mr-3">
                            <button class="btn btn-sm btn-light border rounded bg-transparent btnheight pr-5 pl-5">{{'shipment.Assign' |
                              cxTranslate}}</button>
                          </div>
                          <div *ngIf="(shipdata.shipmentArrivalStatusCode !='NEW'&& shipdata.shipmentArrivalStatusCode != 'COMPLETED')"
                            class="mr-3">
                            <button class="btn btn-sm btn-light border rounded bg-transparent btnheight"
                              (click)="gotoDeatils(shipdata,'update')">{{'shipment.UpdateInformation' | cxTranslate}}</button>
                          </div>
                        </div> -->


                         <div class="hr mt-0 mb-3"></div>
                  <div class="mx-3 mb-3 d-flex justify-content-between">
                      <div class="d-none d-md-block d-lg-block mt-2 ml-1">
                          <div class="strong text-primary pe-auto" (click)="gotoDeatils(shipdata,'view')">
                            {{'shipment.Viewdetails' | cxTranslate}} ></div>
                      </div>
                      <div class="d-md-none d-lg-none mt-2">
                          <div class="strong text-primary pe-auto" (click)="gotoDeatils(shipdata,'view')">
                            {{'shipment.Viewdetails' | cxTranslate}} ></div>
                      </div>
                      <div *ngIf="(shipdata.shipmentArrivalStatusCode =='NEW')" class="mr-3">
                        <button class="btn btn-sm btn-light border rounded bg-transparent btnheight pr-5 pl-5">{{'shipment.Assign' | cxTranslate}}</button>
                      </div>
                      <div *ngIf="(shipdata.shipmentArrivalStatusCode !='NEW'&& shipdata.shipmentArrivalStatusCode != 'COMPLETED' && !shipdata.enablePortInvoiceButton)" class="mr-3">
                        <button class="btn btn-sm btn-light border rounded bg-transparent btnheight" (click)="gotoDeatils(shipdata,'update')">{{'shipment.UpdateInformation' | cxTranslate}}</button>
                      </div>
                        <div *ngIf="(shipdata.shipmentArrivalStatusCode === 'COMPLETED' && isAgentInvoiceActive=='true')">
                        <button *ngIf="shipdata.enablePortInvoiceButton != true" class="btn btn-sm strong text-primary btn-light border rounded btnheight pl-5 pr-5 bg-transparent" (click)="openInvoices(shipdata)">{{'shipment.invoice.attachHarborDueInvoice' | cxTranslate}}</button>
                         <button *ngIf="shipdata.enablePortInvoiceButton == true" class="btn btn-sm strong text-primary btn-light border rounded btnheight pl-5 pr-5 ml-3 bg-transparent"
                              (click)="openPortInvoices(shipdata)">{{'shipment.invoice.AttachPortInvoices' | cxTranslate}}</button>
                      </div>
                  </div>
                      </div>


                      <!-- End Mobpqualiile view  -->
                 
              </div>
          </div>
      </div>
      <!-- shipment list code end -->
       <!-- Shipment inspection start -->
      <div class="row flex-wrap" *ngIf="display === 'inspectionPage' || display === 'bondedwarehouseInspectionPage'">
        <div class="col-md-12 col-lg-12 mt-4 " *ngFor="let shipdata of shipmentinspectiondata">
            <div class="card mt-4 mb-4 card-border border-radius-05" >
              <div *ngIf="shipdata.shipmentInspectionStatusCode == 'NEW'" style="background-color:#0A6CB4;" class="card-header borderRadius pb-1">
                  <div class='d-flex justify-content-between'>
                      <div class=""><span class="mr-1"><img class="mb-1" src="./images/ship.svg" alt="icon" width="35" height="20"></span><span class="h5 strong">{{shipdata.nominationNumber}}/{{shipdata.nominationItemNumber| removeLeadingZeros}}</span></div>
                      <div class="d-flex justify-content-between">
                        <span class="mr-5 d-none d-md-block d-lg-block">{{ 'home.quote.Creationdate' | cxTranslate }} {{shipdata.creationDate}}</span>
                        <div class="badge badge badge-light ml-auto fs-12 mb-1">{{shipdata.status}}</div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="shipdata.shipmentInspectionStatusCode == 'ASSIGNED'" style="background-color:#06AD96;" class="card-header borderRadius pb-1">
                      <div class="d-flex justify-content-between">
                          <div class=""><span class="mr-1"><img class="mb-1" src="./images/ship.svg" alt="icon" width="35" height="20"></span><span class="h5 strong">{{shipdata.nominationNumber}}/{{shipdata.nominationItemNumber| removeLeadingZeros}}</span></div>
                          <div class="d-flex justify-content-between">
                          <span class="mr-5 d-none d-md-block d-lg-block">{{ 'home.quote.Creationdate' | cxTranslate }} {{shipdata.creationDate}}</span>
                          <div class="badge badge-indigo ml-auto fs-12 mb-1">{{shipdata.status}}</div>
                        </div>
                        </div>
                      </div>
                  <div *ngIf="shipdata.shipmentInspectionStatusCode == 'INPROGRESS'" style="background-color:#E87202;" class="card-header borderRadius pb-1">  
                    <div class='d-flex justify-content-between'>
                      <div class=""><span class="mr-1"><img class="mb-1" src="./images/ship.svg" alt="icon" width="35" height="20"></span><span class="h5 strong">{{shipdata.nominationNumber}}/{{shipdata.nominationItemNumber| removeLeadingZeros}}</span></div>
                      <div class="d-flex justify-content-between">
                        <span class="mr-5 d-none d-md-block d-lg-block">{{ 'home.quote.Creationdate' | cxTranslate }} {{shipdata.creationDate}}</span>
                      <div class="badge badge-success ml-auto fs-12 mb-1">{{shipdata.status}}</div>
                      </div>
                    </div>
                </div>
                <div *ngIf="shipdata.shipmentInspectionStatusCode == 'COMPLETED'" style="background-color:#6C757D;" class="card-header borderRadius pb-1 pl-2">  
                  <div class='d-flex justify-content-between ml-2'>
                    <div class=""><span class="mr-1"><img class="mb-1" src="./images/ship.svg" alt="icon" width="35" height="20"></span><span class="h5 strong">{{shipdata.nominationNumber}}/{{shipdata.nominationItemNumber| removeLeadingZeros}}</span></div>
                    <div class="d-flex justify-content-between">
                      <span class="mr-5 d-none d-md-block d-lg-block">{{ 'home.quote.Creationdate' | cxTranslate }} {{shipdata.creationDate}}</span>
                    <div class="badge badge badge-completed ml-auto fs-12 mb-1">{{shipdata.status}}</div>
                    </div>
                  </div>
              </div>
                <div class="card-body d-none d-lg-block pb-0">
                    <div class='d-flex py-2 text-break'>
                      <div class="d-none d-md-block d-lg-block col-md-2 padding-set">
                        <div class="h5 mb-0 fw-bold">{{shipdata.vesselName?shipdata.vesselName:'--'}}</div>
                        <div class="small text-secondary">{{shipdata.portName?shipdata.portName:'--'}}</div>
                      </div>
                     
                      <div class="d-none d-md-block d-lg-block col-md-2  padding-set">
                        <div class="small text-secondary">{{'shipment.material' | cxTranslate}}</div>
                        <div class="small text-black">{{shipdata.material?shipdata.material:'--'}}</div>
                      </div>
                    
                       <div class="col-md-6">
                        <div class="row">
                        <div class="d-none d-md-block d-lg-block col-md-3  padding-set ">
                            <div class="small text-secondary">{{'shipment.BLQty' | cxTranslate}}</div>
                            <div class="small" [ngClass]="shipdata.formattedActualQuantity? 'text-black':'text-secondary'">{{shipdata.formattedActualQuantity?shipdata.formattedActualQuantity: '--'}}</div>
                        </div>
                        
                   
                        <div class="d-none d-md-block d-lg-block col-md-3 ">
                          <div class="small text-secondary">{{'shipment.draftSurvey' | cxTranslate}}</div>
                          <div class="small fs-12" [ngClass]="shipdata.draftSurveyQty? 'text-black':'text-secondary'">{{shipdata.draftSurveyQty?shipdata.draftSurveyQty: '--'}}</div>
                      </div>
                        <div class="d-none d-md-block d-lg-block col-md-3 ">
                          <div class="small text-secondary">{{'shipment.startDate' | cxTranslate}}</div>
                          <div class="small fs-12" [ngClass]="shipdata.surveyStartDate?'text-black':'text-secondary'">{{shipdata.surveyStartDate?shipdata.surveyStartDate: 'DD/MM/YYYY'}}</div>
                        </div>
                        <div class="d-none d-md-block d-lg-block col-md-3">
                            <div class="small text-secondary">{{'shipment.endDate' | cxTranslate}}</div>
                            <div class="small fs-12" [ngClass]="shipdata.surveyEndDate?'text-black':'text-secondary'">{{shipdata.surveyEndDate?shipdata.surveyEndDate: 'DD/MM/YYYY'}}</div>
                        </div>
                        </div>
                        </div>
                        <div class="d-none d-md-block d-lg-block col-md-2">
                            <div class="small text-secondary">{{'shipment.inspection_agent' | cxTranslate}}</div>
                            <div class="small fs-12" [ngClass]="shipdata.portSidePartner?'text-black':'text-secondary'">{{shipdata.portSidePartner?shipdata.portSidePartner: '--'}}</div>
                        </div>
                    </div>                            
                </div>
                  <!-- Mobile view in progress/completed tab-->
                  <div class="py-4 d-lg-none">
                 <div class="d-lg-none ml-3 small mt-2">{{ 'home.quote.Creationdate' | cxTranslate }} {{shipdata.creationDate}}</div>
                      <div class="ml-2 d-flex justify-content-between">
                        <div class="h6 ml-2 mb-0 fw-bold">{{shipdata.vesselName?shipdata.vesselName:'--'}}</div>
                           <div class="small mr-3 text-secondary">{{shipdata.portName?shipdata.portName:'--'}}</div>
                           </div>
                        </div>
                   <!-- End  -->
                 <!-- Mobile View Active/Completed tab -->
                <div class="hr mt-0 mb-0 d-lg-none"></div>
                    <div class="ml-3 small mt-2 d-lg-none">{{ 'home.quote.Creationdate' | cxTranslate }} {{shipdata.creationDate}}</div>
                    <div class="py-2 d-lg-none">
                      <div class="row px-3 mt-3">
                          <div class="col-6 small strong text-secondary">{{'shipment.material' | cxTranslate}}</div>
                          <div class="col-6 small text-black">{{shipdata.material?shipdata.material:'--'}}</div>
                      </div>
                        
                        <div class="row px-3 mt-3">
                            <div class="col-6 small strong text-secondary">{{'shipment.BLQty' | cxTranslate}}</div>
                            <div class="col-6 small">{{shipdata.formattedActualQuantity?shipdata.formattedActualQuantity: '--'}}</div>
                        </div>
                        <div class="row px-3 mt-3">
                            <div class="col-6 small strong text-secondary">{{'shipment.draftSurvey' | cxTranslate}}</div>
                            <div class="col-6 small">{{shipdata.draftSurveyQty?shipdata.draftSurveyQty: '--'}}</div>
                        </div>
                        <div class="row px-3 mt-3">
                            <div class="col-6 small strong text-secondary">{{'shipment.startDate' | cxTranslate}}</div>
                            <div class="col-6 small">{{shipdata.surveyStartDate?shipdata.surveyStartDate: 'DD/MM/YYYY'}}</div>
                        </div>
                        <div class="row px-3 mt-3">
                          <div class="col-6 small strong text-secondary">{{'shipment.endDate' | cxTranslate}}</div>
                          <div class="col-6 small">{{shipdata.surveyEndDate?shipdata.surveyEndDate: 'DD/MM/YYYY'}}</div>
                      </div>
                       <div class="row px-3 mt-3">
                          <div class="col-6 small strong text-secondary">{{'shipment.inspection_agent' | cxTranslate}}</div>
                          <div class="col-6 small">{{shipdata.portSidePartner?shipdata.portSidePartner: '--'}}</div>
                      </div>
                    </div>

                    <!-- End Mobile view  -->
                <div class="hr mt-0 mb-3"></div>
                <!-- <div class="d-none d-md-block d-lg-block"> -->
                  <div class="mx-2 mb-3 row">
                    <!-- <div class=" mt-2 ml-1"> -->
                      <div class="col-md-4 mt-2">
                        <div class="strong text-primary pe-auto" *ngIf="activeTab == 'Active'" (click)="updateInspectionInfo(shipdata)">
                          {{'shipment.UpdateInformation' | cxTranslate}} ></div>
                          <div class="col strong text-primary pe-auto p-0" *ngIf="activeTab == 'Completed'" (click)="updateInspectionInfo(shipdata)">
                            {{'shipment.viewInformation' | cxTranslate}} ></div>
                        <!-- <span *ngFor="let file of shipdata.attachments" class="attachment-text pl-2">
                          <span>{{file.documentName}}</span>
                        </span> -->
                          <!-- <div *ngIf="(shipdata.shipmentInspectionStatusCode === 'COMPLETED' && isAgentInvoiceActive=='true')">
                            <button class="btn btn-sm strong text-primary btn-light border rounded btnheight pl-5 pr-5 bg-transparent"
                              (click)="openInvoices(shipdata)">{{'shipment.invoice.attachInvoice' | cxTranslate}}</button>
                      </div> -->
                                          </div>
                      <div [ngClass]="(shipdata.shipmentInspectionStatusCode === 'COMPLETED' && isAgentInvoiceActive=='true') ? 'col-md-6':'col-md-8'" class="small text-secondary mt-2 mt-lg-0">
                        <div class="row mt-2">
                      <div class="col-md-4">
                      <span>{{  'quality.Instructions' | cxTranslate }}:</span>
                      <span class="small fs-12 text-black">
                        {{shipdata.instruction?shipdata.instruction:'--'}}
                      </span>
                        
                    </div>
                    <div class="col-md-4">
                      <span>{{'batches.cargoagent' | cxTranslate}}:</span>
                      <span class="text-blue text-decoration-underline pe-auto ml-2"
                        (click)="openCargoAgentPopup('cargo_agent', shipdata)">{{shipdata.cargoAgent?.name ? shipdata.cargoAgent?.name : 'Unassigned'}}</span>
                    </div>
                    <div class="col-md-4">
                      <span>{{'batches.screening_operator' | cxTranslate}}:</span>
                      <span class="text-blue text-decoration-underline pe-auto ml-2"
                        (click)="openCargoAgentPopup('screening_operator', shipdata)">{{shipdata.screeningAgent?.name ? shipdata.screeningAgent?.name : 'Unassigned'}}</span>
                    </div>
                        </div>
                    
                      </div>
                      <div class="col-md-2" *ngIf="(shipdata.shipmentInspectionStatusCode === 'COMPLETED' && isAgentInvoiceActive=='true')">
                            <button class="btn btn-sm strong text-primary btn-light border rounded btnheight pl-5 pr-5 ml-3 bg-transparent"
                              (click)="openInvoices(shipdata)">{{'shipment.invoice.attachInvoice' | cxTranslate}}</button>
                      </div>
                  <!-- </div> -->   
                </div>
                <!-- <div class="d-md-none d-lg-none">
                  <div class="ml-3 mb-3 d-flex justify-content-between">
                    <div class="mt-2">
                      <div class="btn btn-link text-primary p-0 text-decoration-none" *ngIf="activeTab == 'Active'" (click)="updateInspectionInfo(shipdata)">
                        {{'shipment.UpdateInformation' | cxTranslate}} >
                      </div>
                      <div class="btn btn-link text-primary p-0 text-decoration-none" *ngIf="activeTab == 'Completed'" (click)="updateInspectionInfo(shipdata)">
                        {{'shipment.viewInformation' | cxTranslate}} >
                      </div>
                    </div>
                  </div>
                </div> -->
               
            </div>
        </div>
    </div>
    <!-- Shipment inspection end -->
<!-- </div> -->
</div> 
</div>